import './StockCommissionDetail.scss';

import { faCheckCircle, faClock, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import { formatDate, formatInReal } from '../../commons/util/HallAppUtil';
import { useEffect, useState } from 'react';

import AppCard from '../../commons/cards/AppCard';
import AppLinkButton from '../../commons/buttons/AppLinkButton';
import AppLoading from '../../commons/AppLoading';
import ConfirmModal from '../../commons/modal/ConfirmModal';
import EmptyState from '../../commons/EmptyState';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HallAppToast from '../../commons/HallAppToast';
import MenuTitle from '../../commons/menu/MenuTitle';
import ReportHeader from '../report-full/components/ReportHeader';
import StockAPI from './StockAPI';
import UserService from '../../auth/UserService';
import { useParams } from 'react-router-dom';

const stockAPI = new StockAPI
const userAPI = new UserService()

function StockCommissionDetail() {
    const { employeeId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [details, setDetails] = useState([]);
    const [showModalDelete, setShowModalDelete] = useState(false)
    const [isLoadingModalDelete, setIsLoadingModalDelete] = useState(false)
    const [currentCommission, setCurrentCommission] = useState(null);
    const [showModalPayment, setShowModalPayment] = useState(false);
    const [showLoadingModal, setShowLoadingModal] = useState(false);

    useEffect(() => {
        callGetCommissionDetails()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function isUserAdmin() {
        const user = userAPI.getUserData();
        return user.rules?.length !== 0 && user.rules?.includes("COMPANY");
    }

    const callGetCommissionDetails = async () => {
        try {
            setIsLoading(true);
            const resp = await stockAPI.getCommissionDetails(employeeId);

            const sorted = resp.data.sort((a, b) => {
                // se paymentDate for null/undefined, joga para frente
                if (!a.paymentDate && b.paymentDate) return -1;
                if (a.paymentDate && !b.paymentDate) return 1;

                // se os dois tem ou os dois não tem, ordena pela data (se quiser decrescente: b - a)
                if (a.paymentDate && b.paymentDate) {
                    return new Date(a.paymentDate).getTime() - new Date(b.paymentDate).getTime();
                }

                return 0;
            });

            setDetails(sorted);
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoading(false);
        }
    };


    const deleteProduct = async () => {

        setIsLoadingModalDelete(true)

        try {
            setIsLoading(true)
            await stockAPI.getCancelCommission(employeeId, currentCommission.historyId);
            HallAppToast.success();
            await callGetCommissionDetails()
            setShowModalDelete(false)
            setCurrentCommission({})
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoadingModalDelete(false)
        }
    }

    const confirmPayment = async () => {
        try {
            setShowLoadingModal(true)
            const data = {
                ...currentCommission,
                employeeId,
            }
            await stockAPI.confirmPaymentByHistory(data);
            HallAppToast.success();
            setShowModalPayment(false)
            await callGetCommissionDetails()
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setShowLoadingModal(false)
        }
    }

    const getStatusBadge = (isPending) => {
        return isPending ? (
            <span className="commission-item__badge commission-item__badge--pending" title="Pagamento pendente">
                <FontAwesomeIcon icon={faClock} className="me-1" />
                Pendente
            </span>
        ) : (
            <span className="commission-item__badge commission-item__badge--paid" title="Pagamento realizado">
                <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
                Pago
            </span>
        );
    }

    return (
        <div>
            <ReportHeader name='Detalhes comissão' />
            <div className='container'>
                <MenuTitle title="Detalhes Comissão" />

                {isLoading ? <AppLoading /> :
                    details.length === 0 ? <EmptyState
                        title="Nenhuma comissão encontrada"
                        description="Não há comissões registradas para o período selecionado. Ajuste o filtro de datas ou verifique se há vendas de produtos com comissão."
                        icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}
                    />
                        :
                        details.map((data) => {
                            const isPending = data.status === 'PENDING_PAYMENT';

                            return <AppCard
                                key={data.historyId}
                                className={`commission-item ${isPending ? 'commission-item--danger' : 'commission-item--success'}`}
                            >
                                <div className="commission-item__header">
                                    <h5 className="commission-item__title" title={data.employeeName}>
                                        {data.employeeName}
                                    </h5>
                                    {getStatusBadge(isPending)}
                                </div>

                                <div className="commission-item__body">
                                    <div className="commission-item__row">
                                        <span className="commission-item__label">Produto</span>
                                        <span className="commission-item__value">{data?.productName}</span>
                                    </div>

                                    <div className="commission-item__row">
                                        <span className="commission-item__label">Data da venda</span>
                                        <span className="commission-item__value">{formatDate(data?.saleDate)}</span>
                                    </div>

                                    {!isPending && (
                                        <div className="commission-item__row">
                                            <span className="commission-item__label">Data do pagamento</span>
                                            <span className="commission-item__value">{formatDate(data.paymentDate)}</span>
                                        </div>
                                    )}

                                    <div className="commission-item__row">
                                        <span className="commission-item__label">Valor do produto</span>
                                        <span className="commission-item__value">{formatInReal(data.productValue || 0)}</span>
                                    </div>

                                    <div className="commission-item__row">
                                        <span className="commission-item__label">Comissão</span>
                                        <span className="commission-item__value">{data?.commission}%</span>
                                    </div>

                                    <div className="commission-item__row">
                                        <span className="commission-item__label">Valor da comissão</span>
                                        <span className="commission-item__value commission-item__value--highlight">
                                            {formatInReal(data.commissionValue || 0)}
                                        </span>
                                    </div>

                                    {isPending && (
                                        <p className="commission-item__hint">
                                            Pagamento pendente para este lançamento. Confirme o pagamento quando efetivado.
                                        </p>
                                    )}
                                </div>

                                <div className="commission-item__actions">
                                    {data.paymentDate && (
                                        <AppLinkButton
                                            onClick={() => {
                                                setCurrentCommission(data);
                                                setShowModalDelete(true);
                                            }}
                                            width="100%"
                                            name="Cancelar pagamento"
                                        />
                                    )}

                                    {!data.paymentDate && isUserAdmin() && (
                                        <AppLinkButton
                                            onClick={() => {
                                                setCurrentCommission(data);
                                                setShowModalPayment(true);
                                            }}
                                            width="100%"
                                            name="Marcar como pago"
                                        />
                                    )}
                                </div>
                            </AppCard>
                        })
                }
            </div>

            {showModalPayment && <ConfirmModal show={showModalPayment}
                title='Confirmar pagamento'
                textBtnConfirm="Confirmar"
                isLoading={showLoadingModal}
                confirm={() => confirmPayment()}
                closeModal={() => {
                    setCurrentCommission(null)
                    setShowModalPayment(false)
                }}
            >
                Deseja registrar o pagamento no valor de    <span style={{ fontWeight: 'bold' }}>{formatInReal(currentCommission?.commissionValue || 0)}</span> ?
            </ConfirmModal>}


            {showModalDelete && <ConfirmModal show={showModalDelete}
                title='Cancelar'
                isLoading={isLoadingModalDelete}
                confirm={() => deleteProduct()}
                closeModal={() => {
                    setShowModalDelete(false)
                    setCurrentCommission({})
                }}
            >
                Deseja cancelar o pagamento do produto <span style={{ fontWeight: 'bold' }}>{currentCommission?.productName}</span>
                no valor de <b>{formatInReal(currentCommission?.commissionValue)}</b>?
            </ConfirmModal>}
        </div>
    );
}

export default StockCommissionDetail;
